<template>
  <v-select
    v-model="selectedItem"
    :return-object="returnObject"
    :loading="loading"
    :items="sortedItems"
    item-disabled="disabled"
    :item-value="itemValue"
    :multiple="multiple"
    :label="labelWithId"
    :hide-details="hideDetails"
    :box="box"
    class="whatsapp-sender-select"
    clearable
    autofocus
  >
    <template v-slot:prepend-inner>
      <v-icon color="green" class="mr-0">mdi-whatsapp</v-icon>
    </template>

    <template v-slot:item="{ item }">
      <span
        class="whatsapp-sender d-flex align-center px-2"
        :class="{
          'sender-inactive': item.disabled,
          'grey lighten-2': item.disabled,
          'grey--text text--darken-2': item.disabled,
        }"
      >
        <small v-if="item.id" class="id grey--text text--darken-1">
          #{{ item.id }}
        </small>

        <span class="text-no-wrap">
          {{ item.phone_number || item.sender | phoneNumber }}
        </span>

        <FlaggedIcon
          v-if="item.meta_status && item.meta_status === 'FLAGGED'"
        ></FlaggedIcon>

        <QualityChip
          :quality="item.meta_quality_rating_v2 || item.qualityRating"
        />

        <OwnerChip
          v-if="item.owner"
          :owner="item.owner"
          :tooltip="item.owner"
          icon-only
        />
      </span>
    </template>

    <template v-slot:selection="{ item }">
      <v-tooltip
        bottom
        :disable="
          !selectedItem ||
          !item ||
          !(item.meta_quality_rating_v2 || item.qualityRating)
        "
      >
        <template v-slot:activator="{ on }">
          <span
            v-on="on"
            class="whatsapp-sender d-flex align-center"
            style="overflow: hidden"
          >
            <span class="text-no-wrap">
              {{ item.phone_number || item.sender | phoneNumber }}
            </span>
          </span>
        </template>

        <p class="mb-2">
          <OwnerChip
            v-if="item.owner"
            :owner="item.owner"
            :tooltip="item.owner"
          />
        </p>

        <p>
          <QualityChip
            :quality="item.meta_quality_rating_v2 || item.qualityRating"
          />
        </p>
        <p
          v-if="item.meta_status && item.meta_status === 'FLAGGED'"
          class="mt-2"
        >
          <FlaggedIcon color="white"></FlaggedIcon>
          <span class="ml-1">Sender comprometido</span>
        </p>
      </v-tooltip>
    </template>
  </v-select>
</template>

<script>
import FlaggedIcon from "@/components/ui/FlaggedIcon.vue";

import QualityChip from "@/components/ui/QualityChip.vue";
import OwnerChip from "./ui/OwnerChip.vue";

export default {
  name: "sender-selector",
  components: {
    FlaggedIcon,
    QualityChip,
    OwnerChip,
  },
  props: {
    items: {
      type: Array,
      required: true,
      default: () => [],
    },
    value: {
      type: [Object, String, Number, Array],
      default: null,
    },
    label: {
      type: String,
      default: "Remetente",
    },
    loading: {
      type: Boolean,
      default: false,
    },
    itemValue: {
      type: String,
      default: "id",
    },
    sortBy: {
      type: String,
      default: "id",
    },
    returnObject: {
      type: Boolean,
      default: false,
    },
    box: {
      type: Boolean,
      default: true,
    },
    multiple: {
      type: Boolean,
      default: false,
    },
    hideDetails: {
      type: Boolean,
      default: true,
    },
  },
  emits: ["input"],
  computed: {
    selectedItem: {
      get() {
        return this.value;
      },
      set(newValue) {
        this.$emit("input", newValue);
      },
    },
    labelWithId() {
      const base = this.label || "";
      const sel = this.selectedItem;
      const formatId = (v) => {
        if (!v) return null;
        if (typeof v === "object") return v.id || v[this.itemValue] || null;
        return v;
      };
      if (!sel) return base;
      if (Array.isArray(sel)) {
        const ids = sel
          .map(formatId)
          .filter((x) => x != null)
          .join(", ");
        return ids ? `${base} #${ids}` : base;
      }
      const id = formatId(sel);
      return id ? `${base} #${id}` : base;
    },
    sortedItems() {
      return this.items
        .map((item) => ({
          ...item,
          disabled: item && item.active === false,
        }))
        .sort((a, b) => {
          if (a[this.sortBy] < b[this.sortBy]) return -1;
          if (a[this.sortBy] > b[this.sortBy]) return 1;
          return 0;
        });
    },
  },
};
</script>

<style lang="scss" scoped>
.whatsapp-sender {
  width: 100%;
  border-radius: 4px;
  .id {
    width: 23px;
  }
  gap: 2px;
}

.sender-inactive {
  opacity: 0.55;
  filter: grayscale(0.35);
}
</style>
